import { useReducer, useEffect, useRef } from "react"
import { db } from "../firebase/config"
import { collection, onSnapshot, where, query } from "firebase/firestore"

export const useCollection = (c, _q, _q2, _q3, _q4) => {
  const [state, setState] = useReducer((state, newState) => ({ ...state, ...newState }), {
    loading: true,
    data: null,
  })

  const q = useRef(_q).current
  const q2 = useRef(_q2).current
  const q3 = useRef(_q3).current
  const q4 = useRef(_q4).current

  useEffect(() => {
    let ref = collection(db, c)

    if (q) {
      if (q2 && q3 && q4) {
        ref = query(ref, where(...q), where(...q2), where(...q3), where(...q4))
      } else if (q2 && q3) {
        ref = query(ref, where(...q), where(...q2), where(...q3))
      } else if (q2) {
        ref = query(ref, where(...q), where(...q2))
      } else {
        ref = query(ref, where(...q))
      }
    }

    const unsubscribe = onSnapshot(ref, (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ ...doc.data(), id: doc.id })
      })
      setState({ loading: false, data: results })
    })

    return () => unsubscribe()
  }, [c, q, q2, q3, q4])

  return state
}
